import React from 'react'
import clsx from 'classnames'
import styles from './AppButton.module.scss'

type AppButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Colour of the button's offset shadow, see AppButton.module.scss */
  shadowColor?: string,
}

export const AppButton: React.FC<AppButtonProps> = (props) => {
  const { children, className, shadowColor, ...rest } = props
  return <button
    type={'button'}
    className={clsx([styles.button, className])}
    data-shadow={shadowColor}
    {...rest}
  >
    <span className={styles.content}>{children}</span>
  </button>
}
